import { render, staticRenderFns } from "./searchIndex.vue?vue&type=template&id=21f82bac&scoped=true"
import script from "./searchIndex.vue?vue&type=script&lang=js"
export * from "./searchIndex.vue?vue&type=script&lang=js"
import style0 from "./searchIndex.vue?vue&type=style&index=0&id=21f82bac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f82bac",
  null
  
)

export default component.exports